import React, { createContext, useContext, useState } from "react";

const SortContext = createContext();

export const useSort = () => useContext(SortContext);

export const SortProvider = ({ children }) => {
  const [sortConfig, setSortConfig] = useState({ key: null, direction: null });

  return (
    <SortContext.Provider value={{ sortConfig, setSortConfig }}>
      {children}
    </SortContext.Provider>
  );
};
